/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { LocalVideoTrack } from 'twilio-video';
import { VideoTrack } from '../VideoTrack/VideoTrack';
import { useVideoContext } from '../../../contexts/videoProvider/videoContext';

export namespace LocalPreview {
  export interface Props {}
}

export const LocalPreview: React.FC<LocalPreview.Props> = ({}) => {
  const { localTracks } = useVideoContext();
  const videoTrack = localTracks.find(track => track.name.includes('camera')) as LocalVideoTrack;
  return <VideoTrack track={videoTrack} isLocal />;
};
